
import { AreaAccountingProduct } from "../../classes"

const AreaAccountingProductModule = {
  namespaced: true,
  state: {
    areaAccountingProducts: [],
    areaAccountingProduct: undefined
  },
  mutations: {
    setAreaAccountingProducts(state, areaAccProducts) {
      state.areaAccountingProducts = areaAccProducts || []
    },
    setAreaAccountingProduct(state, areaAccProduct) {
      state.areaAccountingProduct = areaAccProduct 
    },
    addAreaAccountingProduct: (state, areaAccProduct) => {
      state.areaAccountingProducts.push(areaAccProduct);
    },
    updateAreaAccountingProduct: (state, areaAccProduct) => {
      if (areaAccProduct && state.areaAccountingProducts) {
        let index = state.areaAccountingProducts.findIndex(
          i => i.objectId === areaAccProduct.objectId
        );
        if(index == -1){
          state.areaAccountingProducts.push(areaAccProduct)
        }else{
          state.areaAccountingProducts[index] = areaAccProduct;
        }
        
        const temp = state.areaAccountingProducts
        state.areaAccountingProducts = []
        state.areaAccountingProducts = temp
      }
    }
  },
  actions: {
    getAreaAccountingProductByMarket: async ({ commit }, marketId) => {
      try{
        const data = await AreaAccountingProduct.getAreaAccountingProductByMarket(marketId)
        commit("setAreaAccountingProducts", data)
        return data
      }catch(error){
        throw error
      }
    },
    createAreaAccountingProduct: async ({ commit }, formData) => {
      try {
        const data = await AreaAccountingProduct.createAreaAccountingProduct(formData);
        return data;
      } catch (error) {
        throw error;
      }
    },
    updateAreaAccountingProduct: async ({ commit }, formData) => {
      try {
        const data = await AreaAccountingProduct.updateAreaAccountingProduct(formData);
        return data;
      } catch (error) {
        throw error;
      }
    },
    createUpdateAreaAccountingProduct: async ({ commit }, formData) => {
      try {
        const data = await AreaAccountingProduct.createUpdateAreaAccountingProduct(formData);
        return data;
      } catch (error) {
        throw error;
      }
    },
    getAreaAccountingProductByAreas: async ({ commit }, areaIds) => {
      try{
        const data = await AreaAccountingProduct.getAreaAccountingProductByAreas(areaIds)
        commit("setAreaAccountingProducts", data)
        return data
      }catch(error){
        throw error
      }
    },
    getAreaAccountingProduct: async ({ commit }, id) => {
      try{
        const data = await AreaAccountingProduct.getAreaAccountingProduct(id)
        commit("updateAreaAccountingProduct", data)
        return data
      }catch(error){
        throw error
      }
    },
    getAreaAccountingProductPrice: async ({ commit }, formData) => {
      try{
        commit("setAreaAccountingProduct", undefined)
        const data = await AreaAccountingProduct.getAreaAccountingProductPrice(formData)
        commit("setAreaAccountingProduct", data)
        return data
      }catch(error){
        throw error
      }
    },
  },
  getters: {
    areaAccountingProduct: state => state.areaAccountingProduct
  },
};
export default AreaAccountingProductModule;
